export function decodeTrue(): boolean {
	return true;
}

export function decodeFalse(): boolean {
	return false;
}
